module.exports = __webpack_public_path__ + "img/intrusive-thoughts.1880722e.svg";